import React from 'react';
import Text from './Text.js';
import colors from '../theme/colors.js';
import * as Services from '../services/index.js';
import { useTheme } from '@mui/system';
import { ChevronRight as ChevronRightIcon } from '@mui/icons-material';

/**
 * 
 * @param {*} param0 
 */
const Title = ({
  title,
  breadcrumbs,
  subheader,
  customStyle = {}
}) => {
  const theme = useTheme();
  const styles = {
    breadCrumbContent: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 20
    },
    breadCrumbIcon: {
      marginRight: 2,
      fontSize: 20
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      ...customStyle
    }
  }, /*#__PURE__*/React.createElement(Text, {
    largest: true,
    veryBold: true,
    color: colors.mainTextGrey,
    margin: breadcrumbs ? "10px 0 5px 0" : "10px 0 20px 0"
  }, title), breadcrumbs && /*#__PURE__*/React.createElement("div", {
    style: styles.breadCrumbContent
  }, breadcrumbs.map(breadcrumb => /*#__PURE__*/React.createElement(React.Fragment, {
    key: Services.concatTokens(breadcrumb.title)
  }, /*#__PURE__*/React.createElement(Text, {
    onClick: breadcrumb.onClick || null,
    align: "center",
    medium: true,
    margin: "0px 5px 0px 0px",
    display: "inline-block",
    customStyle: {
      letterSpacing: '0.6px',
      cursor: 'pointer'
    },
    link: breadcrumb.link || null
  }, breadcrumb.title), /*#__PURE__*/React.createElement(ChevronRightIcon, {
    style: styles.breadCrumbIcon
  }))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    isSelected: true,
    color: theme.palette.primary.main,
    display: "inline-block",
    customStyle: {
      letterSpacing: '0.6px'
    }
  }, subheader)));
};
export default Title;